/**
 * Field validators for the CVRF (Dealer Vehicle Registration Form) create/edit form.
 * Previously defined inline inside FormVehicleRegistrationForm.jsx.
 */
export const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

export const validatePhone = (phone) => {
    const phoneRegex = /^[+]?[\d\s()-]+$/;
    return phoneRegex.test(phone) && phone.length >= 10;
};

export const validatePostalCode = (code) => {
    const postalRegex = /^[0-9]{5}$/;
    return postalRegex.test(code);
};

// Alanların hangi sırayla/isimle zorunlu olduğunu tek yerde tanımlar.
// Önceden handleSave içinde 13 alanlık tek bir && zinciriyle kontrol ediliyordu;
// hangi alanın eksik olduğu ayırt edilemiyordu. Artık bu liste üzerinden dönülüyor.
export const CVRF_REQUIRED_FIELDS = [
    'chassisNo',
    'vehiclePlate',
    'kmInformation',
    'vehicleRegistration',
    'nameCompany',
    'customerPhone',
    'customerEmail',
    'customerAddress',
    'customerStreet',
    'customerHome',
    'customerCity',
    'customerPostalCode',
    'customerCountry'
];

export const getMissingRequiredFields = (formData) => CVRF_REQUIRED_FIELDS.filter((field) => !formData[field]);
